import { Routes, Route } from 'react-router-dom'
import Footer from '@/core/components/globals/footer'
import Header from "@/core/components/globals/header"
import Sidebar from '@/core/components/globals/sidebar'
import { lazy, Suspense } from 'react'
import Loading from '@/core/components/globals/loading'
import { useModalStore } from '@/store/modal/store'
import DvModal from '@/core/components/modal/dv-modal'
import DepositTransferModal from '@/core/components/modal/deposit-transfer'
import KycRequiredModal from '@/core/components/modal/kyc-required'
import BuyDvxModal from '@/core/components/modal/buy-dvx'

const TermsOfUse = lazy(() => import('@/pages/TermsOfUse'))
const LegalNotices = lazy(() => import('@/pages/LegalNotices'))
const CookiePolicy = lazy(() => import('@/pages/CookiePolicy'))
const Fees = lazy(() => import('@/pages/Fees'))

export default function LegalLayout() {
  // Utiliser des sélecteurs explicites pour garantir la réactivité avec Zustand 5
  const modal = useModalStore((state) => state.modal);
  const setModal = useModalStore((state) => state.setModal);

  return (
    <>
      <Sidebar />
      <div id="content" className="custom-scrollbar legal-page-content">
        <Header />
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Loading /></div>}>
          <Routes>
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/legal-notices" element={<LegalNotices />} />
            <Route path="/cookie-management-policy" element={<CookiePolicy />} />
            <Route path="/fees" element={<Fees />} />
            <Route path="/*" element={<TermsOfUse />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>

      {/* Modals pour les actions du header */}
      <DvModal 
        open={!!modal.deposit || !!modal.transfer || !!modal.withdraw} 
        onClose={() => setModal({ deposit: false, transfer: false, withdraw: false })}
      >
        <DepositTransferModal />
      </DvModal>
      <KycRequiredModal />
      <DvModal open={!!modal.buyDvx} onClose={() => setModal({ buyDvx: false })}>
        <BuyDvxModal />
      </DvModal>
    </>
  )
}
